const TENANT_NAME = process.env.REACT_APP_TENANT_NAME;
const ENV = process.env.REACT_APP_ENV;

export const getTenant = () => {
  switch (TENANT_NAME) {
    case 'ici':
      return 'bhcipcce';
    case 'business-lending':
      return 'sba';
    default:
      return TENANT_NAME;
  }
};

export const getEnv = () => {
  return ENV || 'dev';
};

const configData = require(`./tenants/${getTenant()}.json`);

export const isAmazonLayout = () => {
  return TENANT_NAME === 'amazon';
};

export const getLandingLogo = () => {
  const images = require.context('./../assets/images/logos', true);
  try {
    const imageName = configData?.landingLogoName;
    return images(`./${imageName}`);
  } catch (error) {
    console.log(error);
    return images(`./lendistryLogoSecondary.png`);
  }
};

export const getHeaderLogo = () => {
  const images = require.context('./../assets/images/logos', true);
  try {
    const imageName = configData?.header.logoName;
    return images(`./${imageName}`);
  } catch (error) {
    console.log(error);
    return images(`./logo.svg`);
  }
};

export const getLogoBanner = () => {
  const images = require.context('./../assets/images/logos', true);
  // Change to a default image
  const depricatedlandingImage = require.context('./../assets/images/landing', true);
  try {
    const imageName = configData?.header.logoBanner;
    return imageName ? images(`./${imageName}`) : '';
  } catch (error) {
    console.log(error);
    return depricatedlandingImage(`./title.png`);
  }
};

export const getFooterLogo = () => {
  const images = require.context('./../assets/images/logos', true);
  try {
    const imageName = configData?.footer.logoName;
    return images(`./${imageName}`);
  } catch (error) {
    console.log(error);
    return images(`./lendistryLogoSecondary.png`);
  }
};

export const autorenewSession =
  configData?.sessionSettings?.autorenewSession === undefined
    ? true
    : configData?.sessionSettings?.autorenewSession;
export const noActionTimeout = parseInt(configData?.sessionSettings?.noActionTimeout) || 90000;
export const showRenewModalTimeout =
  parseInt(configData?.sessionSettings?.showRenewModalTimeout) || 90000;

export default {
  isAmazonLayout,
  landingLogo: getLandingLogo(),
  headerLogo: getHeaderLogo(),
  footerLogo: getFooterLogo(),
  getTenant,
  getEnv,
  ...configData,
};
